/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LearnMoreResponseAdminDto } from '../../models/learn-more-response-admin-dto';

export interface AdminLearnMoreControllerTogglePublishV1$Params {
  id: string;
}

export function adminLearnMoreControllerTogglePublishV1(http: HttpClient, rootUrl: string, params: AdminLearnMoreControllerTogglePublishV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LearnMoreResponseAdminDto>> {
  const rb = new RequestBuilder(rootUrl, adminLearnMoreControllerTogglePublishV1.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LearnMoreResponseAdminDto>;
    })
  );
}

adminLearnMoreControllerTogglePublishV1.PATH = '/v1/admin/learn-more/{id}/publish';
